import {ImageUploaderCropper} from "./ImageUploaderCropper";
import React, {useState} from "react";

interface ImageUploaderProps {
  handleUploadedImage: (url: string) => void;
  isSquareCropper: boolean;
  uploadFolder: string;
  uploadedImageUrl: string;
  placeholder?: string;
  placeholderBgColor?: string;
  cropEnabled?: boolean;
}

export const ImageUploader = ({
  handleUploadedImage,
  isSquareCropper,
  uploadFolder,
  uploadedImageUrl,
  placeholder = '未上傳封面圖片',
  placeholderBgColor = 'bg-gray-200',
  cropEnabled = true,
}: ImageUploaderProps) => {
  const [isUploadMode, setIsUploadMode] = useState<boolean>(false);


  const onUploadedImage = (url: string) => {
    setIsUploadMode(false);
    handleUploadedImage(url);
  }

  const switchUploadMode = () => {
    setIsUploadMode(true);
  }

  if (isUploadMode) {
    return (
      <ImageUploaderCropper
        isSquare={isSquareCropper}
        onUploaded={onUploadedImage}
        folder={uploadFolder}
        cropEnabled={cropEnabled}
      />
    )
  }

  return (
    <button
      type="button"
      onClick={switchUploadMode}
      className={`relative ${cropEnabled ? 'w-[200px] h-[200px]' : 'max-w-[100%] max-h-[200px]'} rounded-md overflow-hidden group`}
    >
      {uploadedImageUrl
        ? (
          <img
            src={uploadedImageUrl}
            className={`${cropEnabled ? 'w-[200px] h-[200px]' : 'max-w-[100%] max-h-[200px]'} rounded-md`}
            alt=""
          />
        )
        : (
          <div className={`w-[200px] h-[200px] ${placeholderBgColor} flex justify-center items-center rounded-md text-gray-600`}>
            {placeholder}
          </div>
        )
      }
      <div
        className={`
          absolute inset-0 bg-black bg-opacity-0 group-hover:bg-opacity-40 flex justify-center items-center
          transition-all duration-200
        `}
      >
        <span className="text-white text-sm opacity-0 group-hover:opacity-100 transition-opacity duration-200">
          {uploadedImageUrl ? '重新上傳' : '上傳圖片'}
        </span>
      </div>
    </button>
  )
}